/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundFaxPaginationDto } from './InboundFaxPaginationDto';
import {
    InboundFaxPaginationDtoFromJSON,
    InboundFaxPaginationDtoFromJSONTyped,
    InboundFaxPaginationDtoToJSON,
    InboundFaxPaginationDtoToJSONTyped,
} from './InboundFaxPaginationDto';
import type { InboundFaxResponseDto } from './InboundFaxResponseDto';
import {
    InboundFaxResponseDtoFromJSON,
    InboundFaxResponseDtoFromJSONTyped,
    InboundFaxResponseDtoToJSON,
    InboundFaxResponseDtoToJSONTyped,
} from './InboundFaxResponseDto';

/**
 * 
 * @export
 * @interface InboundFaxListResponseDto
 */
export interface InboundFaxListResponseDto {
    /**
     * 
     * @type {Array<InboundFaxResponseDto>}
     * @memberof InboundFaxListResponseDto
     */
    data: Array<InboundFaxResponseDto>;
    /**
     * 
     * @type {InboundFaxPaginationDto}
     * @memberof InboundFaxListResponseDto
     */
    pagination: InboundFaxPaginationDto;
}

/**
 * Check if a given object implements the InboundFaxListResponseDto interface.
 */
export function instanceOfInboundFaxListResponseDto(value: object): value is InboundFaxListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function InboundFaxListResponseDtoFromJSON(json: any): InboundFaxListResponseDto {
    return InboundFaxListResponseDtoFromJSONTyped(json, false);
}

export function InboundFaxListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundFaxListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(InboundFaxResponseDtoFromJSON)),
        'pagination': InboundFaxPaginationDtoFromJSON(json['pagination']),
    };
}

export function InboundFaxListResponseDtoToJSON(json: any): InboundFaxListResponseDto {
    return InboundFaxListResponseDtoToJSONTyped(json, false);
}

export function InboundFaxListResponseDtoToJSONTyped(value?: InboundFaxListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(InboundFaxResponseDtoToJSON)),
        'pagination': InboundFaxPaginationDtoToJSON(value['pagination']),
    };
}

